/* sb-dc-tplflags.js - Design Templates 페이지에 «Flags / Yard Sign» 을 붙이고,
   사이즈에 맞는 파일만 보여 준다. 2026-09-10 (v2).

   보고 3건 (전부 라이브에서 재현 확인)
   ---------------------------------
   ① 상품 고르는 칸(#sbdt-product)에 항목이 13개뿐 — 깃발 5종과 야드사인이 없다.
   ② All Templates 에서 깃발 디자인을 누르면 Vinyl Banner 로 열린다.
   ③ (2026-09-10 디자이너) «S/M/L 을 각각 만들어 올리면 세 사이즈 화면에 셋 다
      나오는가?» — 지금 분류가 «계열» 단위라 그렇다.

   ②의 원인: 카드의 data-href 는 «지금 고른 상품» 을 product= 로 달고 나간다.
   상품을 안 고랐으면(All products) product= 가 없고, 디자인센터는 기본값인
   커스텀 비닐 배너로 열어 판도 가격도 틀린 상품이 된다.

   섹션 파일은 안 건드린다
   ----------------------
   셀 다 sections/sb-dc-templates.liquid(78KB, 한국어 주석 다수) 안에 있지만 테마
   API 는 파일을 통째로만 받으므로 바깥에서 덧붙인다. 페이지 자체는 이미 깃발을
   완전히 지원한다 — ?product=feather-angled-flag-small 로 열면 제대로 걸러진다.
   빠진 건 «고를 수단» 뿐이었다.

   하는 일
   -------
   1) #sbdt-product 에 <optgroup>Flags & Signs</optgroup> 6항목 추가. 고르면 그 핸들로
      ?product= 를 붙여 다시 열고(섹션의 자체 change 처리와 안 싸우게 capture 단계에서
      stopImmediatePropagation), URL 이 이미 깃발이면 그 항목을 선택 상태로 보인다.
   2) 상품을 안 고랐을 때, 깃발·야드사인 카드의 data-href 에 product= 를 채운다.
      사이즈는 템플릿의 가로세로 비에 제일 가까운 것으로 고른다.
   3) **사이즈 필터**(v2): 깃발 상품을 고른 상태에서, 그 계열에 사이즈가 다른 파일이
      둘 이상 있으면 **지금 판과 비율이 맞는 것만** 남기고 나머지 카드는 감춘다.
      계열에 한 종류뿐이면 아무것도 안 감춘다 — 지금처럼 계열당 한 장만 있는 상태에서
      갑자기 목록이 비지 않게 하려는 안전장치다.

   진단: window.__dcTplFlags() */
(function () {
  'use strict';

  /* 패밀리별 사이즈. 상품 대표 이미지에 인쇄된 값(2026-09-10 전수 확인),
     sb-dc-yardflag.js 의 FLAG_ROWS 와 같은 값이다. 한쪽을 고치면 다른 쪽도. */
  var FAMS = [
    { key: 'feather-angled', label: 'Feather Angled Flag', sizes: [
      ['feather-angled-flag-small', 23.5, 78.5],
      ['feather-angled-flag-medium', 24, 104],
      ['feather-angled-flag-large', 28, 138],
      ['feather-angled-flag-x-large', 24, 183.5]
    ] },
    { key: 'feather-convex', label: 'Feather Convex Flag', sizes: [
      ['feather-convex-flag-small', 20, 82],
      ['feather-convex-flag-medium', 24, 104],
      ['feather-convex-flag-large', 28, 138]
    ] },
    { key: 'teardrop-flag', label: 'Teardrop Flag', sizes: [
      ['teardrop-flag-small', 23.17, 63.52],
      ['teardrop-flag-medium', 32.54, 78.64],
      ['teardrop-flag-large', 40.38, 101.63]
    ] },
    { key: 'rectangle-flag', label: 'Rectangle Flag', sizes: [
      ['rectangle-flag-small', 31, 90.5],
      ['rectangle-flag-medium', 31, 114],
      ['rectangle-flag-large', 31, 151.5]
    ] },
    { key: 'econo-feather', label: 'Econo Feather Flag', sizes: [
      ['econo-feather-flag', 30.75, 137.75]
    ] },
    { key: 'yard-sign', label: 'Yard Sign', sizes: [
      ['yard-sign', 24, 18]
    ] }
  ];

  var BY_KEY = {}, BY_HANDLE = {};
  FAMS.forEach(function (f) {
    BY_KEY[f.key] = f;
    f.sizes.forEach(function (s) { BY_HANDLE[s[0]] = f; });
  });

  var info = { picker: false, added: 0, rows: 0, patched: 0, hidden: 0, filtering: '', why: '' };
  window.__dcTplFlags = function () { return info; };

  function param(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  var CUR = param('product');

  /* ---------- 1. 상품 고르는 칸 ---------- */

  function addOptions() {
    var sel = document.getElementById('sbdt-product');
    if (!sel) return false;
    if (sel.querySelector('optgroup[data-sbflags]')) return true;

    var g = document.createElement('optgroup');
    g.label = 'Flags & Signs';
    g.setAttribute('data-sbflags', '1');
    FAMS.forEach(function (f) {
      var o = document.createElement('option');
      o.value = 'sbflag:' + f.sizes[0][0];
      o.textContent = f.label;
      g.appendChild(o);
      info.added++;
    });
    sel.appendChild(g);
    info.picker = true;

    if (BY_HANDLE[CUR]) {
      var want = 'sbflag:' + BY_HANDLE[CUR].sizes[0][0];
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === want) { sel.selectedIndex = i; break; }
      }
    }

    sel.addEventListener('change', function (e) {
      var v = sel.value || '';
      if (v.indexOf('sbflag:') !== 0) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      var u = new URL(location.href);
      u.searchParams.set('product', v.slice(7));
      u.searchParams.delete('tpl');
      location.href = u.toString();
    }, true);

    return true;
  }

  /* ---------- 2~3. 행 정보 ---------- */

  var ROWS = null;      /* id -> { fam, ratio } */
  var SIZES = null;     /* fam -> { handle: 개수 } */

  function handleFor(rec) {
    var f = BY_KEY[rec.fam];
    if (!f) return '';
    if (!rec.ratio) return f.sizes[0][0];
    var best = f.sizes[0], bd = Infinity;
    f.sizes.forEach(function (s) {
      var d = Math.abs((s[1] / s[2]) - rec.ratio);
      if (d < bd) { bd = d; best = s; }
    });
    return best[0];
  }

  function loadRows() {
    var sb = window.__dcSupabase;
    if (!sb || !sb.url || !sb.anonKey) { info.why = 'no supabase handle'; return; }
    var url = sb.url + '/rest/v1/dc_templates?select=id,products,width_px,height_px'
            + '&active=eq.true&limit=5000';
    fetch(url, { headers: { apikey: sb.anonKey, Authorization: 'Bearer ' + sb.anonKey } })
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        if (!Array.isArray(rows)) { info.why = 'bad rows'; return; }
        ROWS = {}; SIZES = {};
        rows.forEach(function (r) {
          var ps = r.products || [], i;
          for (i = 0; i < ps.length; i++) {
            if (!BY_KEY[ps[i]]) continue;
            var w = +r.width_px || 0, h = +r.height_px || 0;
            var rec = { fam: ps[i], ratio: (w > 0 && h > 0) ? w / h : 0 };
            ROWS[r.id] = rec;
            var hnd = handleFor(rec);
            if (!SIZES[rec.fam]) SIZES[rec.fam] = {};
            SIZES[rec.fam][hnd] = (SIZES[rec.fam][hnd] || 0) + 1;
            break;
          }
        });
        info.rows = Object.keys(ROWS).length;
        sweep();
      })
      .catch(function (e) { info.why = 'fetch failed: ' + (e && e.message); });
  }

  /* 사이즈 필터를 켜도 되는가 — 지금 계열에 사이즈가 둘 이상일 때만 */
  function filtering() {
    var f = BY_HANDLE[CUR];
    if (!f || !SIZES || !SIZES[f.key]) return false;
    return Object.keys(SIZES[f.key]).length > 1;
  }

  function patchCard(c) {
    var h = c.getAttribute('data-href');
    if (!h) return;
    var u;
    try { u = new URL(h, location.origin); } catch (e) { return; }
    var id = u.searchParams.get('tpl');
    var rec = id && ROWS ? ROWS[id] : null;

    /* 상품이 비어 있으면 깃발·야드사인만 채운다 */
    if (!u.searchParams.get('product') && rec) {
      var hnd = handleFor(rec);
      if (hnd) {
        u.searchParams.set('product', hnd);
        c.setAttribute('data-href', u.pathname + u.search);
        if (c.getAttribute('data-sbflag-done') !== '1') { info.patched++; c.setAttribute('data-sbflag-done', '1'); }
      }
    }

    /* 사이즈 필터 */
    if (!filtering()) {
      if (c.getAttribute('data-sbflag-hide') === '1') {
        c.style.removeProperty('display');
        c.removeAttribute('data-sbflag-hide');
      }
      return;
    }
    var mine = rec && BY_HANDLE[CUR] && rec.fam === BY_HANDLE[CUR].key;
    var drop = mine && handleFor(rec) !== CUR;
    if (drop && c.getAttribute('data-sbflag-hide') !== '1') {
      c.style.setProperty('display', 'none', 'important');
      c.setAttribute('data-sbflag-hide', '1');
      info.hidden++;
    } else if (!drop && c.getAttribute('data-sbflag-hide') === '1') {
      c.style.removeProperty('display');
      c.removeAttribute('data-sbflag-hide');
    }
  }

  function sweep() {
    if (!ROWS) return;
    info.filtering = filtering() ? CUR : '';
    var cards = document.querySelectorAll('.sbdt-card');
    for (var i = 0; i < cards.length; i++) patchCard(cards[i]);
  }

  var watching = false;
  function watch() {
    if (watching) return true;
    var grid = document.getElementById('sbdt-grid') || document.querySelector('.sbdt-grid');
    if (!grid) return false;
    sweep();
    try {
      new MutationObserver(function () { sweep(); })
        .observe(grid, { childList: true, subtree: true });
      watching = true;
    } catch (e) {}
    return true;
  }

  var tries = 0;
  var t = setInterval(function () {
    tries++;
    var a = addOptions();
    var b = watch();
    if ((a && b) || tries > 60) clearInterval(t);
  }, 250);

  addOptions();
  loadRows();
})();
